import { useCallback, useState } from 'react';
import { useUser } from '../../providers/UserProvider';
import { gpSeenRelease, shouldShowRelease } from './seenRelease';
import { useMarkGpReleaseSeen } from './useMarkGpReleaseSeen';

// Bumping this shows the modal once to every GP user, so change it in the same
// commit as the slides in WhatsNewContent.tsx; the value is compared for equality only.
export const CURRENT_RELEASE = '1.60.0';

interface UseWhatsNewResult {
    shouldShow: boolean;
    onDismiss: () => void;
}

export function useWhatsNew(): UseWhatsNewResult {
    const { user } = useUser();
    const markSeen = useMarkGpReleaseSeen('Failed to mark whats new as seen:');
    const [dismissed, setDismissed] = useState(false);

    const seen = gpSeenRelease(user?.database?.data);
    const shouldShow = !dismissed && shouldShowRelease(seen, CURRENT_RELEASE);

    const onDismiss = useCallback(() => {
        setDismissed(true);
        void markSeen(CURRENT_RELEASE);
    }, [markSeen]);

    return { shouldShow, onDismiss };
}
